"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UpperMenu;
const react_1 = __importDefault(require("react"));
const jit_load_1 = __importDefault(require("~/helpers/jit-load"));
const give_today_1 = __importDefault(require("~/models/give-today"));
const use_optimized_image_1 = __importDefault(require("~/helpers/use-optimized-image"));
require("./upper-menu.scss");
const menuStructure = {
    Bookstores: 'https://he.kendallhunt.com/sites/default/files/uploadedFiles/Kendall_Hunt/OPENSTAX_PRICE_LIST_and_ORDER_FORM.pdf',
    'Our Impact': '/impact',
    Supporters: '/foundation',
    Blog: '/blog',
    Give: 'https://riceconnect.rice.edu/donation/support-openstax-header',
    Help: 'https://help.openstax.org/s/'
};
const menuData = Object.entries(menuStructure).map(([key, value]) => ({ label: key, url: value }));
function MenuItem({ label, url, showButton }) {
    if (label === 'Give') {
        return showButton ?
            null :
            react_1.default.createElement("li", { className: "nav-menu" },
                react_1.default.createElement("a", { target: "_blank", rel: "noreferrer", href: url }, label));
    }
    return (react_1.default.createElement("li", { className: "nav-menu" },
        react_1.default.createElement("a", { href: url }, label)));
}
const importGiveButton = () => Promise.resolve().then(() => __importStar(require('../give-button/give-button')));
function UpperMenu() {
    const { showButton } = (0, give_today_1.default)();
    const riceLogo = (0, use_optimized_image_1.default)('https://openstax.org/dist/images/rice.webp', 80);
    return (react_1.default.createElement("menu", { className: "container", "data-analytics-nav": "Upper Menu" },
        menuData.map(({ label, url }) => react_1.default.createElement(MenuItem, { key: label, label: label, url: url, showButton: showButton })),
        react_1.default.createElement("li", { className: "logo rice-logo logo-wrapper" },
            react_1.default.createElement("a", { href: "http://www.rice.edu" },
                react_1.default.createElement("img", { src: riceLogo, alt: "Rice University logo", height: "30", width: "79" }))),
        showButton ? react_1.default.createElement(jit_load_1.default, { importFn: importGiveButton }) : null));
}
